import { Box, SxProps, Typography } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

const KinnectLandingPage = ({
  children,
  sx,
  cardSx,
  headerSx,
}: {
  children: ReactNode;
  sx?: SxProps;
  cardSx?: SxProps;
  headerSx?: SxProps;
}): ReactElement => {
  return (
    <Box
      sx={{
        backgroundColor: '#F2F2F4',
        height: '100vh',
        width: '100vw',
        margin: 0,
        paddingX: 0,
        paddingY: 5,
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <Box
        sx={{
          backgroundColor: '#FFF',
          borderRadius: 5,
          width: {
            md: '70%',
            sm: '80%',
            xs: '90%',
          },
          maxWidth: 750,
          paddingY: 5,
          boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
          ...cardSx,
        }}
      >
        <Typography sx={{ textAlign: 'center', paddingY: 7, ...headerSx }}>
          <Typography
            sx={{
              textAlign: 'center',
              fontFamily: 'LemonMilkRegular',
              fontSize: 60,
            }}
          >
            Kinnect
          </Typography>
          {children}
        </Typography>
      </Box>
    </Box>
  );
};

export default KinnectLandingPage;
